module.exports = __webpack_public_path__ + "img/whatsapp-icon-black.f4ffb1d8.svg";